import React from 'react';
import {IconButton} from '@mui/material';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import ReplayCircleFilledIcon from '@mui/icons-material/ReplayCircleFilled';

export const ArdItemMenu = props => {
  const [posChecked, setPosChecked] = React.useState(props.locked);

  const [hiddenChecked, setHiddenChecked] = React.useState(props.hidden);

  const handleLockClicked = () => {
    const value = !posChecked;
    if (props.item.inherited) {
      return;
    }
    props.onLock(value);
    props.setShowMenu(false);
    setPosChecked(value);
  };
  const handleHideClicked = () => {
    const value = !hiddenChecked;
    props.onHide(value);
    setHiddenChecked(value);
    props.setShowMenu(false);
  };
  return (
    <div className='item-menu'>
      <div className='box'></div>
      <div className='box'>
        <IconButton
          disabled={props.item.data.hideable === false}
          size='small'
          onClick={() => handleHideClicked()}>
          {hiddenChecked ? <VisibilityOffIcon /> : <RemoveRedEyeIcon />}
        </IconButton>
      </div>
      <div className='box'>
        <IconButton
          disabled={props.item.data.movable === false}
          size='small'
          onClick={() => handleLockClicked()}>
          {posChecked ? <LockIcon /> : <LockOpenIcon />}
        </IconButton>
      </div>
      <div className='box'>
        <IconButton
          size='small'
          defaultChecked={posChecked}
          onClick={() => props.onReset()}>
          <ReplayCircleFilledIcon />
        </IconButton>
      </div>
    </div>
  );
};
